export const SITE_URL = 'https://xdigital.com.ph';
export const SITE_NAME = 'XDigital IT Consultancy';
export const SITE_TAGLINE = 'AI Solutions & Enterprise Software Philippines';
export const SITE_DESCRIPTION =
  'Philippine-based AI solutions provider offering enterprise software, AI integration, custom chatbots, and 11 AI-powered products for businesses in the Philippines and Southeast Asia.';
export const SITE_EMAIL = 'sales@xdigital.com.ph';
export const SITE_ADDRESS = 'Pampanga, Philippines';
export const CHAT_IFRAME_URL = 'https://chathub.ph/E6E1B7';
export const SITE_LOCALE = 'en_PH';
export const SITE_LANGUAGE = 'en-PH';

// Set to true to show the products page, nav link, and catalog sections again.
export const SHOW_PRODUCTS = false;

// Set to false to restore the full marketing site.
export const MAINTENANCE_MODE = true;

export const SOCIAL_PROFILES = [
  'https://www.facebook.com/xdigitalph',
  'https://www.linkedin.com/company/xdigitalph',
  'https://twitter.com/xdigitalph',
];

export const PUBLIC_ROUTES = [
  { path: '/', name: 'Home', changefreq: 'weekly', priority: '1.0' },
  { path: '/about', name: 'About', changefreq: 'monthly', priority: '0.8' },
  ...(SHOW_PRODUCTS ? [{ path: '/products', name: 'Products', changefreq: 'weekly', priority: '0.9' }] : []),
  { path: '/services', name: 'Services', changefreq: 'monthly', priority: '0.9' },
  { path: '/invest', name: 'Invest', changefreq: 'monthly', priority: '0.6' },
  { path: '/contact', name: 'Contact', changefreq: 'monthly', priority: '0.8' },
];

export function getCanonicalUrl(pathname = '/') {
  const base = SITE_URL.replace(/\/$/, '');
  if (!pathname || pathname === '/') return `${base}/`;
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${base}${path}`;
}
